// extracted by mini-css-extract-plugin
export default {"card":"IOQSV","iconClose":"ZakQ1","contentFooter":"HfakE","mainFooter":"oB7Aj","footer":"RDypA","content":"I3rlp","wrapper":"f3r7Q","preview":"j4Eds","name":"uOsHl"};